module.exports = __webpack_public_path__ + "img/9_101.6242f8f5.png";